import { post } from '@/common/request';
import { PropertyValue } from './place';

const replayMap = new Map([
  ['list', '/tenant/review/task/page'],
  ['batch', '/tenant/review/task/update/employee'],
  ['commit', '/tenant/review/record/commit'],
  ['detail', '/tenant/review/record/detail'],
  ['placeProperty', '/tenant/review/record/place/property'],
  ['spotProperty', '/tenant/review/record/spot/property'],
  ['save', '/tenant/review/snapshot/create'],
  ['snapshotDetail', '/tenant/review/snapshot/detail']
]);

interface SearchParams {
  priority?: {
    maxValue: number;
    minValue: number
  };
  tenantPlaceName?: string;
  employeeIdList?: number[];
  typeList?: number[];
};

export interface ReplayInfo {
  tenantPlaceId?:	number;
  tenantPlaceName?:	string;
  priority?: number;
  typeNameList?: string[]
  employeeList?:	any[]
  createTime?: string
  createUser?: string
  status?: number
  statusType?: string;
  statusName?: string;
  rejectReason?:	string
}

interface Response {
  pageNum?: number;
  pageSize?: number;
  objectList?: ReplayInfo[];
}

interface ReplayDetail {
  supplierId?: number;
  person?: string
  visitDate?:	string;
  visitDateString?:	string;
  visitType?:	number;
  remark?: string;
  tntReviewPlacePropertyList?: ReplayProper[];
  tntReviewSpotPropertyList?: ReplayProper[];
  tenantPlaceId?:	number;
}

interface ReplayProper {
  reviewRecordId?: number;
  tenantPlaceId?:	number;
  propertyId?: number;
  propertyValue?:	string;
}


export function getList(page: number, size: number, searchParams?: SearchParams): Promise<Response> {
  return post('/tenant/review/task/page', { page, size, ...searchParams }, { proxyApi: '/resserv', needHint: true });
}

export function batchEmployee(reviewTaskId, employeeIdList): Promise<boolean> {
  return post('/tenant/review/task/update/employee', { reviewTaskId, employeeIdList }, { proxyApi: '/resserv', needHint: true });
}

export function detail(id: number): Promise<{snapshot: ReplayDetail}> {
  return post('/tenant/review/record/detail', { id }, { proxyApi: '/resserv', needHint: true });
}

export function snapshotDetail(id: number): Promise<{snapshot: ReplayDetail}> {
  return post('/tenant/review/snapshot/detail', { id }, { proxyApi: '/resserv', needHint: true });
}

export function commit(reviewTaskId: number, info: ReplayProper, tntReviewPlacePropertyList?: ReplayProper[], tntReviewSpotPropertyList?: ReplayProper): Promise<boolean> {
  return post('/tenant/review/record/commit', { reviewTaskId, tntReviewPlacePropertyList, tntReviewSpotPropertyList, ...info }, { proxyApi: '/resserv', needHint: true });
}

export function save(reviewTaskId: number, snapShot: any): Promise<boolean> {
  return post(replayMap.get('save'), { reviewTaskId, snapShot: JSON.stringify(snapShot) }, { proxyApi: '/resserv', needHint: true });
}

export function getPlacePropertys(reviewTaskId: number): Promise<{tenantPlaceName?: string, tenantPlaceId?: string, propertyValueVOList?: PropertyValue }> {
  return post('/tenant/review/snapshot/create', { reviewTaskId }, { proxyApi: '/resserv', needHint: true });
}

export function getSpotPropertys(reviewTaskId: number, tenantSpotId: number): Promise<PropertyValue[]> {
  return post('/tenant/review/record/spot/property', { reviewTaskId, tenantSpotId }, { proxyApi: '/resserv', needHint: true });
}



export default replayMap;
